import{gql as r}from"@apollo/client";const t=r`
  mutation createDirectory($address: AddressInputType, $directory: CreateDirectoryInput!, $tagIds: [Int]) {
    directory {
      createDirectory(address: $address, directory: $directory, tagIds: $tagIds) {
        id
      }
    }
  }
`;export{t as CREATE_DIRECTORY_MUTATION};
//# sourceMappingURL=useCreateDirectory.graphql.js.map
